<div class="spinner" [attr.data-cy]="'contentLoader'">
    <div class="loaderContainer">
        <ng-lottie width="500" [options]="lottieConfig"></ng-lottie>
    </div>
</div>
